var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutOfRoomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FFEAE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.0204V8H7V31H21V25",
    stroke: "#DB004F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2169 19.8839C36.705 19.3957 36.705 18.6043 36.2169 18.1161L28.2619 10.1612C27.7738 9.67301 26.9823 9.67301 26.4942 10.1612C26.006 10.6493 26.006 11.4408 26.4942 11.9289L33.5652 19L26.4942 26.0711C26.006 26.5592 26.006 27.3507 26.4942 27.8388C26.9823 28.327 27.7738 28.327 28.2619 27.8388L36.2169 19.8839ZM16.9997 17.75C16.3093 17.75 15.7497 18.3096 15.7497 19C15.7497 19.6904 16.3093 20.25 16.9997 20.25V17.75ZM35.333 17.75L16.9997 17.75V20.25L35.333 20.25V17.75Z",
    fill: "#DB004F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfRoomIcon);
export default __webpack_public_path__ + "static/media/outOfRoomIcon.55acfe7c60b45a0c7abf90be1c94b778.svg";
export { ForwardRef as ReactComponent };